import { render } from "./AdminManageProduct.vue?vue&type=template&id=71ac8626"
import script from "./AdminManageProduct.vue?vue&type=script&lang=js"
export * from "./AdminManageProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__